interface ComparisonItem {
  feature: string;
  proximus: boolean | string;
  traditionalHotel: boolean | string;
}

interface ComparisonTableProps {
  items: ComparisonItem[];
}

export default function ComparisonTable({ items }: ComparisonTableProps) {
  return (
    <div className="bg-white rounded-xl shadow-subtle overflow-hidden border border-border">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-primary text-white">
              <th className="px-6 py-4 text-left font-display text-lg font-semibold">Feature</th>
              <th className="px-6 py-4 text-center font-display text-lg font-semibold">Proximus</th>
              <th className="px-6 py-4 text-center font-display text-lg font-semibold">Traditional Hotel</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, index) => (
              <tr key={index} className={index % 2 === 0 ? 'bg-muted/30' : 'bg-white'}>
                <td className="px-6 py-4 text-text-primary font-medium">{item.feature}</td>
                <td className="px-6 py-4 text-center">
                  {typeof item.proximus === 'boolean' ? (
                    item.proximus ? (
                      <svg className="w-6 h-6 text-success mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    ) : (
                      <svg className="w-6 h-6 text-error mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    )
                  ) : (
                    <span className="text-text-secondary text-sm">{item.proximus}</span>
                  )}
                </td>
                <td className="px-6 py-4 text-center">
                  {typeof item.traditionalHotel === 'boolean' ? (
                    item.traditionalHotel ? (
                      <svg className="w-6 h-6 text-success mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    ) : (
                      <svg className="w-6 h-6 text-error mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    )
                  ) : (
                    <span className="text-text-secondary text-sm">{item.traditionalHotel}</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}